import { PrefixedId } from './prefixed-id';

export const NavItemId = PrefixedId('nid::');
export type NavItemId = PrefixedId<typeof NavItemId>;
export const nid = NavItemId.create;
